module.exports = __webpack_public_path__ + "img/four.313ee5db.jpg";